
import APIResponse from './APIResponse';

export default APIResponse;



// WEBPACK FOOTER //
// ./src/API/APIResponse/index.js